import { motion, AnimatePresence } from 'framer-motion';
import { CaretDown } from '@phosphor-icons/react';
import { useState } from 'react';
import { useLang } from '@/context/LanguageContext';
import { UI_TEXT } from '@/data/tradeData';

export default function FAQ({ items }) {
  const { lang } = useLang();
  const t = UI_TEXT[lang].faq;
  const [open, setOpen] = useState(null);

  if (!items || items.length === 0) return null;

  return (
    <section data-testid="faq-section" className="py-24 sm:py-32 border-t border-white/5">
      <div className="max-w-3xl mx-auto px-6 lg:px-12">
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }} className="mb-12">
          <p className="uppercase text-xs tracking-[0.2em] font-bold text-[#E31937] mb-4">FAQ</p>
          <h2 className="font-display font-bold text-2xl sm:text-3xl tracking-tight text-white">{t.title}</h2>
        </motion.div>
        <div className="divide-y divide-white/10">
          {items.map((item, i) => (
            <motion.div key={i} initial={{ opacity: 0, y: 10 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.05 }}>
              <button data-testid={`faq-${i}`} onClick={() => setOpen(open === i ? null : i)}
                className="w-full py-5 flex items-center justify-between text-left group">
                <span className={`text-sm font-semibold transition-colors ${open === i ? 'text-white' : 'text-[#A3A3A3] group-hover:text-white'}`}>{item.q}</span>
                <CaretDown size={18} className={`shrink-0 ml-4 text-[#666] transition-transform duration-300 ${open === i ? 'rotate-180 text-[#E31937]' : ''}`} />
              </button>
              <AnimatePresence>
                {open === i && (
                  <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: 'auto', opacity: 1 }} exit={{ height: 0, opacity: 0 }} transition={{ duration: 0.3 }}>
                    <p className="text-sm text-[#A3A3A3] leading-relaxed pb-5">{item.a}</p>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
